import React, { useEffect } from 'react';
import { ControlledFileUpload } from 'features/offline-reports/support-requests/components/support-requests-modals/components/inputs/controlled-file-upload';
import type {
    PropertyFormValues,
    RequestPropertyFormProps,
} from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { validateSupportFile } from 'features/offline-reports/support-requests/components/support-requests-modals/utils/validate-support-file/validate-support-file';
import styles from './upload-file-request-property.module.scss';
import { useFormContext } from 'react-hook-form';
import { supportRequestOriginalFileStore } from 'features/offline-reports/support-requests/store/property-store';
import { useSetAtom } from 'jotai';

const supportedFormats: string[] = [
    'text/csv',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
];
const MAX_FILES = 1;
const LIMITATIONS_TEXT = 'CSV format only, up to 20K rows';
const TEMPLATE_FILE_URL =
    'https://storage.googleapis.com/dashboard-static-prod/templates/support-ticket-template.csv';

export const UploadFileRequestProperty = ({ onNextHandler }: RequestPropertyFormProps) => {
    const setSupportRequestOriginalFile = useSetAtom(supportRequestOriginalFileStore);
    const formController = useFormContext<PropertyFormValues>();
    const files = formController.getValues('file');

    useEffect(() => {
        formController.trigger('file');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const validateFile = async () => {
            if (files?.length && files[0]) {
                const result = await validateSupportFile(files[0]);

                if (!result.isValid) {
                    formController.setError('file', {
                        type: 'manual',
                        message: result.error,
                    });

                    return;
                }

                if (result.parsedData) {
                    // setParsedData(result.parsedData);
                    formController.setValue('parsedData', result.parsedData);
                    formController.setValue('matching', {}); // TODO - remove this line after using private form controller in file-fields-mapping.tsx
                    formController.clearErrors('file'); // clearing PREVIOUS errors if any
                    const isValid = await formController.trigger('file');

                    if (isValid) {
                        setSupportRequestOriginalFile(files[0]);
                        formController.setValue('file', []);
                        onNextHandler?.();
                    }
                }
            }
        };

        try {
            validateFile();
        } catch (e) {
            console.error(e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files]);

    return (
        <div className={styles.fileUploadContainer}>
            <ControlledFileUpload
                testId="property-file-upload"
                control={formController.control}
                name="file"
                required
                variant="container"
                maxFiles={MAX_FILES}
                formats={supportedFormats}
                feedback={[]}
                limitationsText={LIMITATIONS_TEXT}
                templateFileUrl={TEMPLATE_FILE_URL}
                helpButtonProps={{
                    size: 'large',
                    tooltip: 'Learn more',
                    'data-elevio-inline': '851',
                    'data-elevio-style': 'nothing',
                }}
                withSizeLimitMessage={false}
            />
        </div>
    );
};
